import { render, staticRenderFns } from "./TipModel.vue?vue&type=template&id=11afb31a&scoped=true"
import script from "./TipModel.vue?vue&type=script&lang=js"
export * from "./TipModel.vue?vue&type=script&lang=js"
import style0 from "./TipModel.vue?vue&type=style&index=0&id=11afb31a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11afb31a",
  null
  
)

export default component.exports